import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    padding: '32px 168px',
  },
  addUserSection: {
    height: '40px',
    marginBottom: '50px',
  },
  usersSection: {
    width: '100%',
    display: 'flex',
  },
  existingTeamMembersSection: {
    width: '50%',
    paddingRight: '16px',
  },
  accessRequestsSection: {
    width: '50%',
    paddingLeft: '16px',
  },
  sectionHeaderTitle: {
    color: '#152C73',
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  cmbUserSelection: {
    width: '50%',
    float: 'left',
  },
  btnAddUser: {
    marginLeft: '10px',
  },
  userImage: {
    display: 'inline-block',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    fontWeight: 'normal',
    fontSize: '10px',
    marginRight: '8px',
  },
  ownerInfo: {
    position: 'absolute',
    right: '10px',
  },
  lstTeam: {
    width: '100%',
    listStyle: 'none',
    padding: 0,
    fontSize: '0.875rem',
    '& li:first-child': {
      marginBottom: '12px',
    },
    '& li': {
      padding: '0 8px',
      position: 'relative',
      width: '100%',
      height: '40px',
      borderRadius: '4px',
      marginBottom: '4px',
      display: 'inline-flex !important',
      alignItems: 'center !important',
      backgroundColor: '#FFF',
    },
  },
  userOptions: {
    fontSize: '0.875rem',
    position: 'absolute',
    right: '10px',
  },
  ddlUserOptions: {
    fontSize: '0.875rem',
    '& li': {
      fontSize: '0.875rem !important',
    },
  },
  programNameLink: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: 'rgb(2, 123, 253)',
  },
  accessReqGroup: {
    marginTop: '12px',
  },
  reqDate: {
    fontSize: '0.75rem',
    marginBottom: '4px',
    display: 'flex',
    color: '#617080',
  },
  lstAccessRequests: {
    marginTop: 0,
    marginBottom: '16px',
    width: '100%',
    listStyle: 'none',
    padding: 0,
    '& li': {
      width: '100%',
      minHeight: '80px',
      padding: '8px',
      position: 'relative',
      borderRadius: '4px',
      marginBottom: '4px',
      backgroundColor: '#E5E7ED',
      color: '#333',
      display: 'flex',
      flexDirection: 'column',
      verticalAlign: 'middle',
    },
  },
  accessRequestorSection: {
    lineHeight: '30px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  accessRequestLevelSection: {
    lineHeight: '20px',
    padding: '0 8px 0 32px',
    display: 'inline-flex',
    position: 'relative',
    fontSize: '0.8rem',
    color: '#617080',
    alignItems: 'center',
  },
  accessReasonSection: {
    lineHeight: '20px',
    padding: '0 8px 0 32px',
    position: 'relative',
    fontSize: '0.8rem',
    color: '#617080',
  },
  accessRequestorName: {
    fontSize: '0.875rem',
    fontWeight: 700,
    alignItems: 'center',
  },
  accessRequestActionButtons: {
    position: 'absolute',
    right: 0,
  },
  btnAccessRequestAction: {
    height: '24px',
    marginLeft: '8px',
  },
  ddlAccessRequestLevelChange: {
    marginLeft: '4px',
    fontSize: '0.875rem',
  },
  accessTypeDesign: {
    marginLeft: '0px',
    marginRight: '20px',
    marginTop: '5px',
    fontSize: '0.875rem',
  },
  messageText: {
    fontFamily: 'inherit',
    width: '500px',
    minHeight: '80px',
    margin: '0px',
    paddingTop: '0px',
    resize: 'none',
  },
  denyAccess: {
    // cursor: 'pointer',
    color: 'rgb(235, 64, 52)',
    textTransform: 'none',
  },
  allowAccess: {
    height: '32px !important',
    borderRadius: '4px !important',
    backgroundColor: 'rgb(10, 163, 99) !important',
    color: '#fff !important',
    fontSize: '0.8rem !important',
    padding: '10px 10px 10px 5px !important',
    textTransform: 'unset !important',
  },
  dialogContent: {
    marginTop: '32px',
  },
}));
